import graphql__9c6401edb690635a7830 from "./__generated__/CancelSubscriptionDialog_subscription.graphql.ts";
import graphql__593f4e31629642d30bf6 from "./__generated__/CancelSubscriptionDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import Row from "../form/Row";
import FormDialog from "../dialog/FormDialog";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import {useErrorContext} from "../../contexts/ErrorContext";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useIntl} from "react-intl";

type CancelSubscriptionDialogProps = {
    queryRef: any,
    handleCloseDialog: () => {}
}

const CancelSubscriptionDialog: React.FC<CancelSubscriptionDialogProps> = (props) => {

    const intl = useIntl();
    const subscription = useFragment(
        graphql__9c6401edb690635a7830,
        props.queryRef
    );

    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling(
            relayEnvironment,
            {
                mutation: graphql__593f4e31629642d30bf6,
                variables: {
                    input: input
                },
                onCompleted: (response, errors) => {
                    props.handleCloseDialog();
                },
                onError: (error) => {
                    props.handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToCancelSubscription'})
            }
        )
    }

    return (
        <FormDialog handleCloseDialog={props.handleCloseDialog}
                    handleSubmission={handleSubmission}
                    initialValues={{id: subscription.id}}
                    headline={intl.formatMessage({id: 'dialog.CancelSubscriptionDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'dialog.CancelSubscriptionDialog.submitLabel'})}
                    dangerous={true}>
            <Section>
                <Row>
                    <div className="text-gray-900 font-medium">
                        {intl.formatMessage({id: 'dialog.CancelSubscriptionDialog.confirmMessage'}, {
                            service: subscription.subscriptionService.name,
                            reference: subscription.subscriptionServiceReferenceLabel
                        })}
                    </div>
                </Row>
                <Row>
                    {intl.formatMessage({id: 'dialog.CancelSubscriptionDialog.hint'}, {
                        customer: subscription.customerAccount.customerName
                    })}
                </Row>
            </Section>
        </FormDialog>
    )
}

export default CancelSubscriptionDialog;
